import { ShoppingCart } from 'lucide-react';
import { useHesapBranding } from '../../store/hesapBrandingStore';

// Yüklenen logo varsa onu, yoksa varsayılan ikon kutusunu gösterir
export const BrandLogo = ({ boxClass = 'w-9 h-9 rounded-xl', iconClass = 'h-4 w-4', testId = 'brand-logo' }) => {
  const logoUrl = useHesapBranding(s => s.logoUrl);
  if (logoUrl) {
    return (
      <div className={`${boxClass} bg-white flex items-center justify-center overflow-hidden flex-shrink-0 shadow-lg`} data-testid={testId}>
        <img src={logoUrl} alt="Logo" className="w-full h-full object-contain p-0.5" />
      </div>
    );
  }
  return (
    <div className={`${boxClass} bg-gradient-to-br from-emerald-400 to-emerald-600 flex items-center justify-center shadow-lg shadow-emerald-500/30 flex-shrink-0`} data-testid={testId}>
      <ShoppingCart className={`${iconClass} text-white`} />
    </div>
  );
};
